import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { useIsOwner, useSession } from "./lib/auth.ts";
import { formatLongDate, todayISO } from "./lib/day.ts";
import { History } from "./pages/History.tsx";
import { Login } from "./pages/Login.tsx";
import { Progress } from "./pages/Progress.tsx";
import { Settings } from "./pages/Settings.tsx";
import { Today } from "./pages/Today.tsx";

const TABS = [
  { to: "/", label: "Hoy", icon: "\u{1F4DD}", end: true },
  { to: "/historial", label: "Historial", icon: "\u{1F4C5}", end: false },
  { to: "/evolucion", label: "Evolución", icon: "\u{1F4C8}", end: false },
  { to: "/ajustes", label: "Ajustes", icon: "\u{2699}\u{FE0F}", end: false },
];

export function App() {
  const { data: session, isPending } = useSession();
  const isOwner = useIsOwner();

  if (isPending) {
    return (
      <div className="center-screen">
        <div className="spinner" role="status" aria-label="Cargando" />
      </div>
    );
  }

  if (!session) return <Login />;

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar__title">
          <h1>Ánimo</h1>
          <span className="topbar__date">{formatLongDate(todayISO())}</span>
        </div>
        {/* Las mismas secciones para los dos roles; lo que cambia es que un
            `viewer` las ve sin los formularios ni los botones de accion. */}
        {!isOwner && <span className="pill">Solo lectura</span>}
      </header>

      <nav className="nav" aria-label="Secciones">
        {TABS.map((tab) => (
          <NavLink key={tab.to} to={tab.to} end={tab.end} className="nav__item">
            <span className="nav__icon" aria-hidden="true">{tab.icon}</span>
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <main className="app__main">
        <Routes>
          <Route path="/" element={<Today />} />
          <Route path="/historial" element={<History />} />
          <Route path="/evolucion" element={<Progress />} />
          <Route path="/ajustes" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
